<div *ngIf="testHistory?.length >= 1" class="card noprint">
	<app-component-loader
		[loading]="LoaderService.loadingTestHistory"
	></app-component-loader>
	<div class="btn-group">
		<ngb-pagination
			[collectionSize]="testHistory.length * 10"
			[(page)]="page"
			class="w-100"
		>
			<ng-template ngbPaginationPrevious>
				<button type="button" class="btn btn-lg btn-primary h-100 w-100">
					<i class="fa fa-backward" aria-hidden="true"></i>
				</button>
			</ng-template>
			<ng-template ngbPaginationNext>
				<button type="button" class="btn btn-lg btn-primary h-100 w-100">
					<i class="fa fa-forward" aria-hidden="true"></i>
				</button>
			</ng-template>
			<ng-template ngbPaginationPages let-page let-pages="testHistory">
				<!-- <div class="dropdown show">
					<a class="btn dropdown-toggle btn-lg w-100" href="#" role="button" id="dropdownMenuLink" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
						Phase 2 <i class="ml-3 fa fa-caret-down" style="opacity: 0.2"></i>
					</a>
					<div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
						<a class="dropdown-item" href="#">Action</a>
					</div>
				</div> -->
				<div ngbDropdown class="d-inline-block dropdown-frame">
					<button
						class="btn btn-primary btn-lg w-100 mr-10"
						id="dropdownBasic1"
						ngbDropdownToggle
					>
						{{ testHistory[page - 1].testDate }}
						<i class="ml-3 fa fa-caret-down" style="opacity: 0.2"></i>
					</button>
					<div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="w-100">
						<button
							ngbDropdownItem
							*ngFor="let eachHistory of testHistory; index as i"
							(click)="changePage(i)"
						>
							{{ eachHistory.testDate }}
						</button>
					</div>
				</div>
			</ng-template>
		</ngb-pagination>
	</div>

	<div>
		<div class="h-100 d-inline-block w-100 \">
			<div class="table-container-th">
				<table class="table bg-primary table-striped p-5">
					<tr
						*ngFor="
							let eachQuestion of testHistory[page - 1].scoredQuestions;
							let i = index
						"
					>
						<td>
							<span
								class="mr-1"
								class="badge badge-secondary labelcolor-{{
									eachQuestion.testId
								}}"
								>{{ eachQuestion.label }}</span
							>
							<span *ngIf="!rsp.media.is_mobile">{{
								eachQuestion.question
							}}</span>
						</td>
						<td width="50px" align="center">
							<div class="h4">
								<div class="text-center badge badge-secondary ng-binding">
									{{ eachQuestion.latestScore }}
								</div>
							</div>
						</td>
						<td width="50px" align="center" *ngIf="canDelete()">
							<div class="h5">
								<div class="text-center badge badge-secondary ng-binding"></div>
								<span
									class="fa fa-trash-o btn btn-lg btn-primary no-bg"
									[ngbPopover]="alertContent"
									popoverTitle=" Delete Score?"
									placement="left"
								></span>
							</div>
							<ng-template #alertContent>
								<div class="d-flex justify-content-center">
									<button
										type="button"
										(click)="deleteThisScore(eachQuestion.testScoreId)"
										class="btn btn btn-success btn-md"
									>
										<i class="fa fa-check-circle-o" aria-hidden="true"></i
										>&nbsp;Yes</button
									>&nbsp;&nbsp;
									<button type="button" class="btn btn btn-danger btn-md">
										<i class="fa fa-ban" aria-hidden="true"></i>&nbsp;No
									</button>
								</div>
							</ng-template>
						</td>
					</tr>
				</table>
			</div>
			<p style="text-align: center">{{ page }}/{{ testHistory.length }}</p>
		</div>
	</div>
</div>
<div class="print" id="test-history-print">
	<table
		class="table table-responsive"
		*ngFor="let node of testHistory; let i = index"
	>
		<tr style="text-align: left">
			<td colspan="3" style="padding-top: 3em; border-top: none">
				<h4 class="marging-top:20px" style="text-align: left">
					Assessed: {{ node.testDate }}
				</h4>
			</td>
		</tr>

		<tr style="text-align: left">
			<td><strong>Challenge</strong></td>
			<td><strong>Description</strong></td>
			<td><strong>Score</strong></td>
		</tr>

		<tr *ngFor="let eachQuestion of node.scoredQuestions; let i = index">
			<td>{{ eachQuestion.label }}</td>
			<td>
				<span *ngIf="!rsp.media.is_mobile">{{ eachQuestion.question }}</span>
			</td>

			<td width="50px">
				<div>
					<div class="text-center">{{ eachQuestion.latestScore }}</div>
				</div>
			</td>
		</tr>
	</table>
</div>
